import { FormControl, FormLabel } from '@mui/material';
import InfoTooltip from '@components/info-tooltip/info-tooltip.tsx';

function InfoTooltipComponent() {
  return (
    <div className="flex flex-col gap-10">
      <h2 className="text-xl font-bold text-gray-800">Info Tooltip</h2>

      <div className="flex flex-col gap-3">
        <p className="font-semibold text-gray-700">Standalone (hover the icon)</p>
        <div className="flex items-center gap-2">
          <span className="text-gray-600">Info icon</span>
          <InfoTooltip text="tooltip_info_date" />
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <p className="font-semibold text-gray-700">Inside a form label</p>
        <FormControl>
          <FormLabel className="flex items-center">
            <span className="reuqired-symbole">*</span>
            Field label
            <InfoTooltip text="tooltip_info_duration" />
          </FormLabel>
        </FormControl>
      </div>
    </div>
  );
}

export default InfoTooltipComponent;
